(function () {
  function getParams() {
    return new URLSearchParams(window.location.search);
  }

  function getVariantFromUrl() {
    try {
      return getParams().get("variant");
    } catch (e) {
      return null;
    }
  }

  function removeVariantFromUrlKeepOthers() {
    var params = getParams();
    if (!params.has("variant")) return null;

    var variantId = params.get("variant");
    params.delete("variant");

    // Guardamos la variante para aplicarla luego
    try { sessionStorage.setItem("hc_pending_variant", variantId); } catch (e) {}

    var newQuery = params.toString();
    var newUrl = window.location.pathname + (newQuery ? "?" + newQuery : "") + window.location.hash;

    // Quitamos variant del URL SIN recargar
    history.replaceState({}, "", newUrl);

    return variantId;
  }

  function getPendingVariant() {
    try { return sessionStorage.getItem("hc_pending_variant"); } catch (e) { return null; }
  }

  function clearPendingVariant() {
    try { sessionStorage.removeItem("hc_pending_variant"); } catch (e) {}
  }

  function fire(el) {
    if (!el) return;
    try { el.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) {}
    try { el.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}
  }

  function findForm() {
    return (
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[data-product-form]') ||
      document.querySelector('product-form form') ||
      null
    );
  }

  function setVariantIdOnForm(variantId) {
    var form = findForm();
    if (!form) return false;

    var idField =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]') ||
      null;

    if (!idField) return false;

    if (String(idField.value) !== String(variantId)) {
      idField.value = variantId;
    }

    fire(idField);

    // eventos extra (por compatibilidad)
    try { document.dispatchEvent(new CustomEvent("variant:change", { detail: { variantId: variantId } })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent("variant:change", { detail: { variantId: variantId } })); } catch (e) {}

    return true;
  }

  async function applyPendingVariant() {
    var variantId = getPendingVariant();
    if (!variantId) return false;

    // esperamos a que el theme termine de montar la PDP/galería
    var ok = setVariantIdOnForm(variantId);

    // reintentos por si Ecomus monta tarde
    if (!ok) return false;

    setTimeout(function () { setVariantIdOnForm(variantId); }, 250);
    setTimeout(function () { setVariantIdOnForm(variantId); }, 700);
    setTimeout(function () { setVariantIdOnForm(variantId); }, 1400);

    // lo dejamos solo para esta carga
    clearPendingVariant();
    return true;
  }

  // 1) Apenas cargue, si viene con ?variant= lo “neutralizamos”
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.indexOf("/products/") !== 0) return;

    var v = removeVariantFromUrlKeepOthers(); // quita ?variant= pero deja ?pr_...
    // 2) Luego aplicamos la variante después del montaje
    setTimeout(function () { applyPendingVariant(); }, 300);
    setTimeout(function () { applyPendingVariant(); }, 900);
  });

  window.addEventListener("load", function () {
    if (window.location.pathname.indexOf("/products/") !== 0) return;
    applyPendingVariant();
  });
})();
